import { render, staticRenderFns } from "./OurPorts.vue?vue&type=template&id=3c3aa711&scoped=true"
import script from "./OurPorts.vue?vue&type=script&lang=js"
export * from "./OurPorts.vue?vue&type=script&lang=js"
import style0 from "./OurPorts.vue?vue&type=style&index=0&id=3c3aa711&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aa711",
  null
  
)

export default component.exports